<template>
  <div>
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <div class="container" style="padding-left: 10%">
      <h2>杭州含情网络技术有限公司</h2>
      <h3>未成年人限制条款</h3>

      <div class="box-con">
        <h3>
          随着网络在青少年中的普及，未成年人接触网络已经成为普遍现象。为保护未成年人健康参，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人提供以下意见：
        </h3>
        <p>
          一、主动控制网络时间。网络只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络中的行为和体验。
        </p>
        <p>二、不参与可能耗费较多时间的网络。未成年人登录后只有周末时间能上线4个小时。</p>
        <p>
          三、不要将网络当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠网络来缓解压力。
        </p>
        <p>
          四、养成积极健康的心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。
        </p>
        <p>
          五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。
        </p>

        <p>
          如有问题可联系杭州含情网络技术有限公司，公司地址：浙江省杭州市临平区乔司街道科城街180号1幢6层601-603、612、615-617室-54 ，联系电话：
          18858145124
        </p>

        <p><br /></p>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  name: "ag",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "杭州含情网络技术有限公司";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.container {
  padding-top: 60px;
  box-sizing: border-box;
  h2 {
    font-size: 21px;
    color: #333;
    text-align: center;
  }
  h3 {
    font-size: 18px;
    color: #333;
    text-align: center;
    margin: 10px 30px;
  }

  .box-con {
    font-size: 14px;
    color: #888;
    line-height: 40px;
    h3 {
      text-align: left;
      margin: 30px 0 20px 0;
      line-height: 39px;
    }
    p {
      text-align: left;
    }
  }
}
</style>
